import { inject, Injectable } from '@angular/core';

import { HttpService } from '../../core/services';
import type { TodoCreatePayload, TodoReorderPayload, TodoUpdatePayload } from './todo.models';

@Injectable({
  providedIn: 'root',
})
export class TodoApi {
  private readonly http = inject(HttpService);

  listTodos() {
    return this.http.get('todos', true);
  }

  createTodo(payload: TodoCreatePayload) {
    return this.http.post('todos', payload, true);
  }

  updateTodo(todoId: string, payload: TodoUpdatePayload) {
    return this.http.put(`todos/${todoId}`, payload, true);
  }

  reorderTodo(todoId: string, payload: TodoReorderPayload) {
    return this.http.post(`todos/${todoId}/reorder`, payload, true);
  }

  deleteTodo(todoId: string) {
    return this.http.delete(`todos/${todoId}`, true);
  }
}
